import API, { defaultConfig } from './config';
import { getLastDayInMonthByMonthAndYear } from '../components/utils/utils'

export const ClientAPI = {
    async getClientById(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientById/' + clientId, config)

            console.log("Response CLIENT: ", response)

            if (response && response.data
                && response.data.rows &&
                response.data.rows.length == 1) {
                return {
                    success: true,
                    body: response.data.rows[0]
                };
            } else {
                return {
                    success: false,
                };
            }



        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientsByCityId(cityId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            console.log("CITY TO GET: ", cityId);
            const response = await API.get('/clients/getClientsByCityId/' + cityId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllActiveClients(consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/activeClients/' + consultingId, config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientsAndLaunchs(orderDirection, advisorId, consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientsAndLaunchs?orderDirection=' + (orderDirection ? orderDirection : 'ASC') + (advisorId ? '&advisorId=' + advisorId : '')
                + ('&consultingId=' + consultingId), config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientsTargets(orderDirection, advisorId, consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientsTargets?orderDirection=' + (orderDirection ? orderDirection : 'ASC') + (advisorId ? '&advisorId=' + advisorId : '')
                + ('&consultingId=' + consultingId), config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientsPolicys(orderDirection, advisorId, consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientsPolicys?orderDirection=' + (orderDirection ? orderDirection : 'ASC') + (advisorId ? '&advisorId=' + advisorId : '')
                + ('&consultingId=' + consultingId), config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getActuarysInfos(year, advisorId, consultingId, search) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getActuarysInfos?' + (advisorId ? 'advisorId=' + advisorId : '')
                + ('&consultingId=' + consultingId)
                + ('&year=' + year)
                + '&search=' + (!search ? "" : search), config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusDairClientsByYear(offset, limit, year, advisorId, consultingId, search, dairStatusIdFilter, monthFilterDair, dpinStatusIdFilter, snapshotDate, sortOrder) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getStatusDairClientsByYear?offset=' + offset
                + '&limit=' + limit
                + '&year=' + year
                + '&consultingId=' + consultingId
                + (advisorId ? '&advisorId=' + advisorId : '')
                + '&search=' + (!search ? "" : search)
                + '&dairStatusIdFilter=' + (!dairStatusIdFilter ? "" : dairStatusIdFilter)
                + '&dpinStatusIdFilter=' + (!dpinStatusIdFilter ? "" : dpinStatusIdFilter)
                + '&monthFilterDair=' + (!monthFilterDair ? "" : monthFilterDair)
                + (snapshotDate ? '&snapshotDate=' + snapshotDate : '')
                + (sortOrder ? '&sortOrder=' + sortOrder : '')
                , config)

            //console.log('getClientsClousuresByYear: ', response);
            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusDpinClientsByYear(offset, limit, year, advisorId, consultingId, search) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getStatusDpinClientsByYear?offset=' + offset
                + '&limit=' + limit
                + '&year=' + year
                + '&consultingId=' + consultingId
                + (advisorId ? '&advisorId=' + advisorId : '')
                + '&search=' + (!search ? "" : search)
                , config)

            //console.log('getClientsClousuresByYear: ', response);
            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusDpinClientsByYearRange(offset, limit, year, startYear, advisorId, consultingId, search, sortOrder, endYear) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getStatusDpinClientsByYearRange?offset=' + offset
                + '&limit=' + limit
                + '&year=' + year
                + '&startYear=' + startYear
                + (endYear ? '&endYear=' + endYear : '')
                + '&consultingId=' + consultingId
                + (advisorId ? '&advisorId=' + advisorId : '')
                + '&search=' + (!search ? "" : search)
                + (sortOrder ? '&sortOrder=' + sortOrder : '')
                , config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusXmlAudespClientsByYear(offset, limit, year, advisorId, consultingId, search, sortOrder) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getStatusXmlAudespClientsByYear?offset=' + offset
                + '&limit=' + limit
                + '&year=' + year
                + '&consultingId=' + consultingId
                + (advisorId ? '&advisorId=' + advisorId : '')
                + '&search=' + (!search ? "" : search)
                + (sortOrder ? '&sortOrder=' + sortOrder : '')
                , config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    //Contatos (institucional + gestores/subgestores) dos clientes ativos da consultoria.
    //Alimenta as abas DAIR/DPIN e Suitability de MarketingScreen; os recortes (status DAIR,
    //vigência do suitability) são feitos no front.
    async getClientsContacts(consultingId, advisorId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            params: {
                consultingId,
                advisorId: advisorId ?? null,
            },
        }

        try {

            const response = await API.get('/clients/getClientsContacts', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listUserActiveClients(userId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/userActiveClients/' + userId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllClientsWithManagers() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/clientsWithManagers', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllClients(offset, orderByDirectionPortfolioClosed) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            let route = offset || offset === 0 ? `/clients?offset=${offset}` : '/clients';
            //Adicionando direção de ordenação em caso de haver o parâmetro orderByDirectionPortfolioClosed
            route = orderByDirectionPortfolioClosed ? route + `&order_by_postfolio_closed=${orderByDirectionPortfolioClosed}` : route;

            const response = await API.get(route, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllClientsByConsulting(offset, orderByDirectionPortfolioInit, orderByDirectionPortfolioClosed, consultingId, onlyUnoV2) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            let route = offset || offset === 0 ? `/clientsByConsulting?offset=${offset}` : '/clients';
            //Adicionando direção de ordenação em caso de haver o parâmetro orderByDirectionPortfolioClosed
            route = orderByDirectionPortfolioInit ? route + `&order_by_postfolio_init=${orderByDirectionPortfolioInit}` : route;
            route = orderByDirectionPortfolioClosed ? route + `&order_by_postfolio_closed=${orderByDirectionPortfolioClosed}` : route;
            route = route + `&consulting_id=${consultingId}`
            route = onlyUnoV2 ? route + '&only_uno_v2=true' : route;

            const response = await API.get(route, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllUsersClientByRole(clientId, roleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client/getAllUsersClientByRole?client_id=${clientId}&role_id=${roleId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllManagers() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client/getAllManagers`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientsBySearch(search) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client/getAllClientsBySearch?search=${search}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientsConsultingBySearch(search, consultingId, onlyUnoV2) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client/getAllClientsConsultingBySearch?search=${search}&consulting_id=${consultingId}` + (onlyUnoV2 ? '&only_uno_v2=true' : ''), config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAprDescriptions(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/aprDescriptions', { client_id: clientId }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAprDescriptionById(aprDescriptionId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getAprDescriptionById', { apr_description_id: aprDescriptionId }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createClient(client) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/create', client, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async saveNewAprDescription(clientId, title, description) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveNewAprDescription', {
                client_id: clientId,
                title: title,
                description: description,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateAprDescriptionActivation(aprDescriptionId, active) {

        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.patch(`/client/updateAprDescriptionActivation/` + aprDescriptionId, { active: active }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listCompareFundsPresets(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/compareFundsPresets', { client_id: clientId }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveCompareFundsPreset(clientId, title, fundsIds, benchmarksIds, fundGroupId, onlyClientFunds) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveCompareFundsPreset', {
                client_id: clientId,
                title: title,
                funds_ids: fundsIds,
                benchmarks_ids: benchmarksIds,
                fund_group_id: fundGroupId || null,
                only_client_funds: onlyClientFunds === true,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async deleteCompareFundsPreset(presetId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/client/deleteCompareFundsPreset/' + presetId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateStatus(clientId, status) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/updateClientStatus', {
                id: clientId,
                status: status,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateClient(clientId, client) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        console.log("CLIENT NA API: ", client);

        try {

            const response = await API.put('/clients/update', {
                id: clientId,
                client: client,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    /**
     * Reseta o fechameto da carteira
     * @param {int} clientId 
     * @param {Date} compareDate data que vai ser usada para a comparação, update e delete de informações
     * @param {String} dateToPortfolioClosed string de fechamento da carteira Ex: 9/2021 
     * @param {Boolean} updateDate indica se deve ou não ser atualizado o fechamento da carteira 
     */
    async resetPortfolio(clientId, compareDate, dateToPortfolioClosed, updateDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/clients/resetPortfolio', {
                client_id: clientId,
                to_compare: compareDate,
                to_portfolio: dateToPortfolioClosed,
                update: updateDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async resetAssets(clientId, toDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/resetAssets', {
                client_id: clientId,
                to_date: toDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async resetAccounts(clientId, toDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/resetAccounts', {
                client_id: clientId,
                to_date: toDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async resetTransactions(clientId, toDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/resetTransactions', {
                client_id: clientId,
                to_date: toDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateClientClosedMonth(clientId, month) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/client/updateClientClosedMonth', {
                client_id: clientId,
                month: month,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateRentInBalancesValidation(balanceValidationId, rent, averageQuota) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        console.log("RENT: ", rent);

        try {

            const response = await API.post('/client/updateRentInBalancesValidation', {

                balance_validation_id: balanceValidationId,
                rent: rent,
                average_quota: averageQuota,

            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientBalancesValidations(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientBalancesValidations/' + clientId, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientBalancesValidationsByYear(selectedYear, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getClientBalancesValidationsByYear', {
                client_id: clientId,
                year: selectedYear,
            }, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAccountsBalancesValidationsByYear(selectedYear, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getClientAccountsBalancesValidationsByYear', {
                client_id: clientId,
                year: selectedYear,
            }, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientInvestmentsBalancesValidationsByYear(selectedYear, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getClientInvestmentsBalancesValidationsByYear', {
                client_id: clientId,
                year: selectedYear,
            }, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientInvestmentsBalancesValidationsByYearAndRegime(selectedYear, clientId, accountRegimeId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getClientInvestmentsBalancesValidationsByYearAndRegime', {
                client_id: clientId,
                year: selectedYear,
                account_regime_id: accountRegimeId,
            }, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientTitlesBalancesValidationsByYearAndRegime(selectedYear, clientId, accountRegimeId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getClientTitlesBalancesValidationsByYearAndRegime', {
                client_id: clientId,
                year: selectedYear,
                account_regime_id: accountRegimeId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientBalancesValidationsByMonthYear(clientId, m, y) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getClientBalancesValidationsByMonthYear', {
                client_id: clientId,
                month: m,
                year: y,
            }, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBalancesRentsByRange(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/getBalancesRentsByRange', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllRentsFundsClient(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getAllRentsFundsClient/' + clientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientLastQuota(clientId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientLastQuota', {
                client_id: clientId,
                month: month,
                year: year,

            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientLastQuotaBySegregationCod(clientId, month, year, segregation_cod) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientLastQuotaBySegregationCod', {
                client_id: clientId,
                month: month,
                year: year,
                segregation_cod: segregation_cod
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientLastQuotaBySegmentCod(clientId, month, year, segment_cod) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientLastQuotaBySegmentCod', {
                client_id: clientId,
                month: month,
                year: year,
                segment_cod: segment_cod
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getPortfolioClosed(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/client/getPortfolioClosed/' + clientId, config)

            if (response.data.rows && response.data.rows[0]) {

                return {
                    success: true,
                    body: response.data.rows[0].portfolio_closed
                };
            } else {
                return {
                    success: false,
                    body: null
                };

            }

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveClientRent(clientRent) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveClientRent', clientRent, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveClientRentSegregation(clientRent) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveClientRentSegregation', clientRent, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveClientRentSegment(clientRent) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveClientRentSegment', clientRent, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveClientRentMoneyBySegment(clientRentMoney) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveClientRentMoneyBySegment', clientRentMoney, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveFundClientRent(fundClientRent) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveFundClientRent', fundClientRent, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveTitleClientRent(titleClientRent) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/saveTitleClientRent', titleClientRent, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientDiaryPlsByRange(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientDiaryPlsByRange', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientDiaryBySegregationAndRange(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientDiaryBySegregationAndRange', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate
            }, config)

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                data: error.response.data
            };
        }

    },

    async getClientRentsInconsistencies(clientId, threshold) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientRentsInconsistencies', {
                client_id: clientId,
                threshold: threshold
            }, config)

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                data: error.response.data
            };
        }

    },

    async getClientSegmentRentsInconsistencies(clientId, threshold) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientSegmentRentsInconsistencies', {
                client_id: clientId,
                threshold: threshold
            }, config)

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                data: error.response.data
            };
        }

    },

    async getClientDiaryBySegmentAndRange(clientId, startDate, endDate, segmentsCods) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getClientDiaryBySegmentAndRange', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
                segments_cods: segmentsCods
            }, config)

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                data: error.response.data
            };
        }

    },

    async getPortfolioClosedsInPeriodByClient(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getPortfolioClosedsInPeriodByClient', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllRentsClientsByPeriod(startDate, endDate, monthBeforeDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getAllRentsClientsByPeriod', {
                start_date: startDate,
                end_date: endDate,
                month_before_date: monthBeforeDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllMoneyRentsSegmentByPeriod(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getAllMoneyRentsSegmentByPeriod', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllMaxQuotasClientsByMonthAndYearAndConsultingId(month, year, consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getAllMaxQuotasClientsByMonthAndYearAndConsultingId', {
                month: month,
                year: year,
                consulting_id: consultingId
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientPortfolioRentsByLimit(clientId, month, year, limit) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const endDate = getLastDayInMonthByMonthAndYear(month, year);

            const response = await API.post('/client/getClientPortfolioRentsByLimit', {
                client_id: clientId,
                limit: limit,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async setBalanceReconciliaded(balanceValidationId,
        userId,
        status,
        typeAsset
    ) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/client/setBalanceReconciliaded', {
                status: status,
                user_id: userId,
                balance_validation_id: balanceValidationId,
                type_asset: typeAsset,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientConciliations(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/client/getAllClientConciliations/' + clientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("Error: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientConciliationsByUser(clientId, searchInputValue) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client/getAllClientConciliationsByUser?client_id=${clientId}&search=${searchInputValue}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("Error: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createBalanceValidation(balanceValidation) { //objId pode ser uma account ou um asset

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/createBalanceValidation', balanceValidation, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createBalanceTitleValidation(balanceValidation) { //objId pode ser uma account ou um asset

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/createBalanceTitleValidation', balanceValidation, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    //Excluir todos os balances validations salvos no banco, utilizado quando se importa 
    //os saldos de uma planilha
    async deleteBalancesYear(clientId, year) { //objId pode ser uma account ou um asset

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/deleteBalancesYear', {
                client_id: clientId,
                year: year,
            }, config)

            //console.log("RESPONSE NO SERVICE: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAprDataById(clientAprDataId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientAprDataById/' + clientAprDataId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async getClientAprData(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientAprData/' + clientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async getClientAprDataByReferenceDate(clientId, referenceDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientAprDataByReferenceDate?client_id=' + clientId + '&reference_date=' + referenceDate, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async updateClientAprData(clientId, data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/createUpdateClientPolicy', {
                client_id: clientId,
                data: data,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async createUpdateClientPolicy(clientPolicy) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/clients/createUpdateClientPolicy', clientPolicy, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async updateLogoClient(clientId, data64) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/updateLogoClient', {
                client_id: clientId,
                img_base64: data64,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateClientCadprevInfos(clientId, infosCadprev) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/updateClientCadprevInfos', {
                client_id: clientId, infos_cadprev: infosCadprev
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientGesconInfos(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/client/getClientGesconInfos/' + clientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateClientGesconInfos(clientId, infosGescon) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/updateClientGesconInfos', {
                client_id: clientId, infos: infosGescon
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async checkHasAssetsInClient(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/client/checkHasAssetsInClient/' + clientId, config)

            return response.data;

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllRelationsClients(month, year, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/client/getAllRelationsClients?month=' + month + '&year=' + year
                + (clientId ? '&client_id=' + clientId : ''), config)

            console.log("RESPONSE: ", response);
            return {
                success: true,
                body: response.data
            }

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBalancesPortfolioMonthByPeriodAndRegime(clientId, regimeId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getBalancesPortfolioMonthByPeriodAndRegime', {
                client_id: clientId,
                regime_id: regimeId,
                startDate: startDate,
                endDate: endDate
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBalancesAndSumTransactionsPortfolioInMonthByPeriod(clientId, startDate, endDate, search, segmentId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client/getBalancesAndSumTransactionsPortfolioInMonthByPeriod', {
                client_id: clientId,
                startDate: startDate,
                endDate: endDate,
                search: search ? search : '',
                segment_id: segmentId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getUpdateLogList(clientId) {

        try {

            const response = await API.get('/client/getUpdateLogList' + (clientId ? `?client_id=${clientId}` : ""), defaultConfig)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("Error: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    /**
     * Observação interna vigente do cliente. Rota restrita por role no servidor: sessões do RPPS
     * recebem 401, por isso o client só chama quando o usuário é interno da LEMA.
     * @param {number} clientId
     * @returns {Promise<{success: boolean, body: object|null}>} body null quando não há observação
     */
    async getClientObservation(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/clients/getClientObservation/' + clientId, config)

            return {
                success: true,
                body: response.data && response.data.rows && response.data.rows.length
                    ? response.data.rows[0]
                    : null
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    /**
     * Grava uma nova versão da observação do cliente. O servidor não sobrescreve: cada edição
     * diferente da anterior vira uma linha nova de histórico.
     * @param {number} clientId
     * @param {string} observation
     * @returns {Promise<{success: boolean, body: object}>} body.changed indica se houve nova versão
     */
    async saveClientObservation(clientId, observation) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/clients/saveClientObservation', {
                client_id: clientId,
                observation: observation,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async getAllActivesClientsIdsAndNamesByConsultingId(consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client/getAllActivesClientsIdsAndNamesByConsultingId?consulting_id=${consultingId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("Error: ", error.response.data);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateClientSuitability(clientId, suitabilityResult) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put(`/client/updateClientSuitability`, {
                client_id: clientId,
                result: suitabilityResult
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("Error: ", error.response.data);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getRentsByPeriod(clientId, startDate, endDate, search, segmentId, accountRegimeId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        console.log("getRentsByPeriod account_regime_id: ", accountRegimeId);

        try {

            const { data: responseRentsByPeriod } = await API.get(`/client/rentsByPeriod?`
                + `client_id=${clientId}`
                + `&start_date=${startDate}`
                + `&end_date=${endDate}`
                + `&segment_id=${segmentId ? segmentId : 0}`
                + `&account_regime_id=${accountRegimeId ? accountRegimeId : 0}`
                + (search ? `&search=${search}` : ""),
                config)

            return responseRentsByPeriod;

        } catch (error) {

            console.log("Error: ", error.response.data);

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}
